import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Quote from '../../images/testimonial/quote.svg';

// Updated testimonial images (Cloudinary)
const testimonialImg1 =
  "https://res.cloudinary.com/dexvxngzg/image/upload/v1764843145/img-2.9f4c436410e277bea9a0_1_mnegli.jpg";

const testimonials = [
  {
    id: '01',
    Des: "QHB handled our home build with precision and care. The team stayed organized, communicated clearly at every stage, and delivered excellent results on schedule.",
    Title: 'Michael Thompson',
    Sub: "New Home Owner",
    image: testimonialImg1,
  },
  {
    id: '02',
    Des: "Building with QHB was a stress-free experience from start to finish. Their professionalism, transparency, and attention to detail truly stood out. ",
    Title: 'Emily Walker',
    Sub: "First-Time Home Builder",
    image: testimonialImg1,
  },
  {
    id: '03',
    Des: "QHB delivered quality workmanship and reliable service throughout our project. Every phase was handled professionally, and timelines were respected.",
    Title: 'David & Rachel Moore',
    Sub: "Home Build Clients",
    image: testimonialImg1,
  },
];


const Testimonial = (props) => {

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dots: true,
                    arrows: false,
                }
            },
        ]
    };

    return (
        <section className={"" + props.hclass}>
            <Slider {...settings} className="testimonial-slider">
                {testimonials.slice(0, 2).map((testimonial, item) => (
                    <div className="item" key={item}>
                        <div className="bg-image">
                            <img src={testimonial.image} alt="testimonial" />
                        </div>
                        <div className="content fade_bottom">
                            <div className="icon">
                                <img src={Quote} alt="quote" />
                            </div>
                            <h3>{testimonial.Des}</h3>
                            <h4>{testimonial.Title}</h4>
                            <span>{testimonial.Sub}</span>
                        </div>
                    </div>
                ))}
            </Slider>
        </section>
    );
}

export default Testimonial;
